export const env = {
  bot: {
    username: import.meta.env.VITE_BOT_USERNAME as string || 'DropeeBot',
    appShortName: 'play',
    shareText: `🎉 Join me on Dropee and start stacking rewards! 🎰
💸 +5k coins and 5 spins just for signing up
💎 +25k coins if you’ve got Telegram Premium
Ready to get your rewards? Let’s play together now! 🚀`,
  },
  api: {
    // baseUrl: 'http://localhost:8787',
    baseUrl: import.meta.env.VITE_API_BASE_URL as string,
  },
  lingo: {
    baseApiUrl: import.meta.env.VITE_LINGO_API_BASE_URL,
  },
  shop: {
    tonPaymentWalletAddress: import.meta.env.VITE_TON_PAYMENT_WALLET_ADDRESS as string,
  },
  sentryDsn: import.meta.env.VITE_SENTRY_DSN as string,
  gtmId: import.meta.env.VITE_GTM_ID as string,
  app: {
    url: import.meta.env.VITE_URL as string,
    isProd: import.meta.env.VITE_ENV === 'prod',
  },
  base: {
    miniappUrl: import.meta.env.VITE_BASE_MINIAPP_URL as string,
  },
  liveOps: {
    // iframeUrl: '/live-ops-template.html',
    iframeUrl: 'https://id-preview--d92f8124-50f0-426d-90be-b69aaa50196a.lovable.app/?__lovable_token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjoiWFpnd2ZYQjZnTlpoaWNyQzVHT1A0akFXUGQ3MyIsInByb2plY3RfaWQiOiJkOTJmODEyNC01MGYwLTQyNmQtOTBiZS1iNjlhYWE1MDE5NmEiLCJub25jZSI6IjNmMjUwZDhlMjljNGFiNTkxMGMwZDIyNTA0ODNhMDI4IiwiYWNjZXNzX3R5cGUiOiJwcm9qZWN0IiwiaXNzIjoibG92YWJsZS1hcGkiLCJzdWIiOiJkOTJmODEyNC01MGYwLTQyNmQtOTBiZS1iNjlhYWE1MDE5NmEiLCJhdWQiOlsibG92YWJsZS1hcHAiXSwiZXhwIjoxNzcwMjgyNzMyLCJuYmYiOjE3Njk2Nzc5MzIsImlhdCI6MTc2OTY3NzkzMn0.ag8Bc6pGwVs16SclvmKQGJD9I6X6uz7fzRA3S3eSYBg',
  },
}
